"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";

export const bindActions = function bindActions() {
  $(".nav-desktop__menu--item--dropdown").on("mouseenter", function () {
    var $trigger = $(this).find(Dom.dropdownTrigger);
    handlers.closeSubnav();
    handlers.openSubnav($trigger);
  });

  $(".nav-desktop__menu--item--dropdown").on("mouseleave", function () {
    handlers.closeSubnav();
  });

  $(Dom.dropdownTrigger).on("click", function (event) {
    event.preventDefault();
    handlers.toggleSubnav($(this));
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      handlers.closeSubnav();
      handlers.closeFlyout();
    }
  });

  $(Dom.drawerTrigger).on("click", function (event) {
    event.preventDefault();
    handlers.toggleMobileNav();
    handlers.mobileNavPadding();
  });

  $(Dom.flyoutTrigger).on("click", function (event) {
    event.preventDefault();
    handlers.openFlyout($(this));
  });

  $(Dom.flyoutClose).on("click", function (event) {
    event.preventDefault();
    handlers.closeFlyout();
  });

  $(Dom.searchTrigger).on("click", function (event) {
    event.preventDefault();
    handlers.toggleSearch();
  });

  $(window).on("resize", function () {
    if ($(window).width() >= 992) {
      handlers.closeMobileNav();
    }
  });

  handlers.mobileNavPadding();
};
